<template>
  <div v-if="visible" class="outer-carousel">
    <Transition name="pop" appear>
      <div
        v-if="visible"
        ref="popup"
        class="modal"
        role="dialog"
        aria-modal="true"
        :aria-label="imageViewerAccessibleLabel"
        tabindex="-1"
      >
        <div class="modal-overlay">
          <div class="card-carousel">
            <div class="card-img">
              <img :src="currentImage" :alt="userUploadedImageAccessibleLabel" />
              <div role="status" class="ra-sr-only">
                {{ focusedPosition + 1 }} {{ paginationOutOfText }} {{ images.length }}
              </div>

              <div v-if="images.length > 1" class="actions">
                <span
                  role="button"
                  tabindex="0"
                  :aria-label="previousText"
                  class="prev"
                  @keydown.space.prevent
                  @keyup.space="prevImage"
                  @keydown.enter="prevImage"
                  @click="prevImage"
                >
                  &#8249;
                </span>
                <span
                  role="button"
                  tabindex="0"
                  :aria-label="nextText"
                  class="next"
                  @keydown.space.prevent
                  @keyup.space="nextImage"
                  @keydown.enter="nextImage"
                  @click="nextImage"
                >
                  &#8250;
                </span>
              </div>
            </div>
            <button
              :aria-label="modalCloseButtonAccessibleLabel"
              class="btn-close-modal"
              @click="closeModal"
            >
              X
            </button>
            <div v-if="showThumbnails" class="thumbnails">
              <div
                v-for="(image, index) in images"
                :key="index"
                :class="['thumbnail-image', focusedPosition === index ? 'active' : '']"
                @click="activateImage(index)"
              >
                <img :src="image" :alt="userUploadedImageAccessibleLabel" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import { trapFocus } from '../../../../../../../shared/utils/dom/focus';

export default {
  name: 'rfp-ratings-list-carousel-modal',
  inject: ['userUploadedImageAccessibleLabel', 'paginationOutOfText', 'previousText', 'nextText'],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    mainPosition: {
      type: Number,
      default: 0,
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    showThumbnails: {
      type: Boolean,
      default: false,
    },
    modalCloseButtonAccessibleLabel: {
      type: String,
      default: '',
    },
    imageViewerAccessibleLabel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      focusedPosition: this.mainPosition,
    };
  },
  computed: {
    currentImage() {
      return this.images[this.focusedPosition];
    },
  },
  watch: {
    mainPosition(n) {
      this.activateImage(n);
    },
    async visible(newVal) {
      if (newVal) {
        await this.$nextTick();
        this.deactivateFocusTrap = trapFocus(this.$refs.popup);
      } else {
        this.deactivateFocusTrap();
        this.deactivateFocusTrap = null;
      }
    },
  },
  created() {
    this.focusedPosition = this.mainPosition;
  },
  mounted() {
    document.addEventListener('keydown', this.handleCloseOnEsc);
  },
  unmounted() {
    this.handleUnmounted();
  },
  destroyed() {
    this.handleUnmounted();
  },
  methods: {
    handleUnmounted() {
      document.removeEventListener('keydown', this.handleCloseOnEsc);
    },
    handleCloseOnEsc(event) {
      if (this.visible && event.key === 'Escape') {
        this.closeModal();
      }
    },
    nextImage() {
      this.focusedPosition + 1 >= this.images.length
        ? (this.focusedPosition = 0)
        : (this.focusedPosition += 1);
    },
    prevImage() {
      this.focusedPosition - 1 < 0
        ? (this.focusedPosition = this.images.length - 1)
        : (this.focusedPosition -= 1);
    },
    activateImage(e) {
      this.focusedPosition = e;
    },
    closeModal() {
      this.$emit('closedmodal');
    },
  },
};
</script>
